module.exports = __webpack_public_path__ + "img/ico-line.11c10797.svg";